export default {
    namespaced: true,
    state: {
        isRememberHttpForAbort: false, // 是否记录正在进行的请求
        abortHttp: {}, // 请求拦截
        userInfo:{},   // 用户信息
        inviteCode: null, // 邀请编码
        headerImg: null, // 头像
    },
    getters: {
        isRememberHttpForAbort: state => state.isRememberHttpForAbort,
        abortHttp: state => state.abortHttp,
        userInfo: state => state.userInfo,
        inviteCode: state => state.inviteCode,
        headerImg: state => state.headerImg,
    },
    mutations: {
        SET_IS_REMEMBER_HTTP_FOR_ABORT(state, payload) {
            state.isRememberHttpForAbort = payload;
        },
        SET_ABORT_HTTP(state, payload) {
            state.abortHttp = payload;
        },
        SET_USER_INFO(state, payload) {
            state.userInfo = payload;
        },
        SET_INVITE_CODE(state, payload) {
            state.inviteCode = payload
        },
        SET_HEADER_IMG(state, payload) {
            state.headerImg = payload
        }
    },
    actions: {
        setIsRememberHttpForAbort({commit, state}, payload) {
            commit('SET_IS_REMEMBER_HTTP_FOR_ABORT', payload);
        },
        setAbortHttp({commit, state}, payload) {
            commit('SET_ABORT_HTTP', payload);
        },
        setUserInfo({commit, state}, payload) {
            commit('SET_USER_INFO', payload);
        },
        setInviteCode({commit, state}, payload){
            commit('SET_INVITE_CODE', payload)
        },
        setHeaderImg({commit, state}, payload){
            commit('SET_HEADER_IMG', payload)
        },
    }
}
